import { css, type Theme } from '@emotion/react';

export const header = (theme: Theme) => css`
  padding: 34px 31px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  @media (max-width: ${theme.breakpoints.tiny}) {
    justify-content: center;
  }
`;

export const socialMedias = (theme: Theme) => css`
  @media (max-width: ${theme.breakpoints.tiny}) {
    display: none;
  }
`;
